import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import MainPage from './pages/MainPage';
import AboutPage from './pages/AboutPage';
import HistoryPage from './pages/HistoryPage';
import EventPage from './pages/EventPage';
import StoryPage from './pages/StoryPage';
import ScrollToTop from './utils/ScrollTop';

function App() {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <div>
        <Header />
        <ScrollToTop />
        <Routes>
          <Route exact path="/" element={<MainPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/history" element={<HistoryPage />} />
          <Route path="/event" element={<EventPage />} />
          <Route path="/event-2025-04" element={<EventPage />} />
          <Route path="/story" element={<StoryPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
